import { call, put, takeLatest, all } from 'redux-saga/effects';
import config from 'config';
import * as actionTypes from '../actionTypes/order';
import getSetCookie from '../cookie';
import apiClient from '../helpers/apiClient';

let _client = null;
let xApiClient = 'desktop';
// conditional imports on compilation
'#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
xApiClient = 'mobilesite';
'#endif'; // eslint-disable-line

function modifiedOrderResponse(order, orderStatus) {
    const oS = order.status;
    const cancellableStatus = oS.cancellableStatus ? oS.cancellableStatus : '';
    const returnableStatus = oS.returnableStatus ? oS.returnableStatus : '';
    const ks = orderStatus[oS.trackingStatus];
    const l = { return_button: null, cancel_button: null, msg: null, status: null, buttons: { a: null, b: null, c: null, d: null, e: null, f: null, g: null } };
    order.ui = l;
    if (ks) {
        for (let k = 0; k < ks.length; k++) {
            if ((ks[k].order_cancellable_status === cancellableStatus) && (ks[k].order_return_status === returnableStatus)) {
                const fx = { return_button: ks[k].return_button, cancel_button: ks[k].cancel_button, msg: ks[k].msg, status: ks[k].status, buttons: { a: ks[k].buttons.a, b: ks[k].buttons.b, c: ks[k].buttons.c, d: ks[k].buttons.d, e: ks[k].buttons.e, f: ks[k].buttons.f, g: ks[k].buttons.g } };
                order.ui = fx;
            }
        }
    }
    return order;
}

function* getOrder({ data: { orderId, dontInitSession, email, isExchange } }) {
    let url = config.apiPath.getOrderDetails;
    const successAction = { type: actionTypes.GET_ORDER_SUCCESS };
    const errorAction = { type: actionTypes.GET_ORDER_FAIL };
    const client = { ..._client };
    const client2 = { ...client };
    const header = isExchange ? { 'X-Service-Type': 'exchange' } : null;
    client.setHeader(header);
    client2.setHeader();
    if (__SERVER__) {
        url = `${url}${orderId || client.req.cookies.orderId}${email ? `?email=${email}` : ''}`;
    } else if (__CLIENT__) {
        if (getSetCookie.getCookie('uploadPrescriptonSMS') !== '') {
            url = `${url}${getSetCookie.getCookie('orderId')}?sha1Email=${getSetCookie.getCookie('uploadPrescriptonSMS')}`;
        } else {
            url = `${url}${orderId || getSetCookie.getCookie('orderId')}`;
            url = email ? `${url}?email=${email}` : url;
        }
    }
    try {
        if (xApiClient === 'mobilesite') {
            const statusUrl = config.msiteGlobals.orderStatusApiUrl + '?v=' + new Date().getTime();
            const responseData = {};
            const data = yield call(async () => Promise.all([client2.get(statusUrl), client.get(url)]));
            responseData.result = modifiedOrderResponse(data[1].result, data[0].result);
            successAction.data = responseData;
        } else {
            const data = yield call(async () => client.get(url));
            successAction.data = data;
        }
        yield put(successAction);
    } catch (err) {
        if (err.status === 401 && __CLIENT__ && !dontInitSession) {
            const data = yield call(async () => client.post(config.apiPath.userSession));
            getSetCookie.setCookie('frontend', data && data.result ? data.result.id : '', 30);
        }
        errorAction.error = err;
        yield put(errorAction);
    }
}

function* getRecentOrder({ pageNo, pageSize }) {
    const url = config.apiPath.getOrderDetails + '?page=' + pageNo + '&page-size=' + pageSize;
    const successAction = { type: actionTypes.PREV_ORDER_SUCCESS };
    const errorAction = { type: actionTypes.PREV_ORDER_FAIL };
    const client = { ..._client };
    client.setHeader();
    try {
        const data = yield call(async () => _client.get(url));
        successAction.data = data;
        yield put(successAction);
    } catch (err) {
        errorAction.error = err;
        yield put(errorAction);
    }
}

export function* runOrderCalls(client) {
    _client = client ? Object.assign({}, client) : apiClient();
    yield all([
        takeLatest(actionTypes.GET_ORDER, getOrder),
        takeLatest(actionTypes.PREV_ORDER_LOAD, getRecentOrder)
    ]);
}
